import React, { useEffect, useRef } from 'react';
import { useTranslation } from '../contexts/LanguageContext';

const MESSAGES = [
    { emoji: '🗺️', key: 'game.wrongWay.wrongTurn' },
    { emoji: '🎯', key: 'game.wrongWay.detour' },
    { emoji: '🧭', key: 'game.wrongWay.deadEnd' },
    { emoji: '🌀', key: 'game.wrongWay.deeper' },
];

export default function WrongWayModal({ show, onClose }) {
    const { t } = useTranslation();
    // Pick a message once per appearance so it stays stable during its lifetime.
    const messageRef = useRef(MESSAGES[0]);
    useEffect(() => {
        if (show) {
            messageRef.current = MESSAGES[Math.floor(Math.random() * MESSAGES.length)];
        }
    }, [show]);

    useEffect(() => {
        if (!show) return undefined;
        const timer = setTimeout(onClose, 2500);
        return () => clearTimeout(timer);
    }, [show, onClose]);

    if (!show) return null;

    const { emoji, key } = messageRef.current;

    return (
        <div className="wrong-way-toast" onClick={onClose} role="alert" aria-live="polite">
            <span className="wrong-way-emoji" aria-hidden="true">{emoji}</span>
            <span className="wrong-way-text">{t(key)}</span>
        </div>
    );
}
